import React, {Component} from "react";
import * as prosConnect from "../prodect/ProsConnect"
import {
    OBJ_STATE_ACT,
    getUserEmail,
    getDevId,
    isSuperUserModeInUse,
    setSuperUserMode,
    setSuperUserOverridePermissions,
    isSuperUserOverridePermissionsInUse,
    isSuperUserModePossible,
    getCustomerTestEmail,
    ATTR_USER_ROLE,
    ROLE_ADMIN,
    ATTR_RULE_NOTIFICATIONS,
    ATTR_RULE_NOTIFICATION_RECURRING_DAY,
    ATTR_NOTIFICATION_DAY,
    ATTR_NOTIFICATION_FOR_NEW_SUBPROJECTS,
    ATTR_PROJECTS,
    UI_LISTED_ELEMENTS_LIMIT, ATTR_RULE_PROJECTS
} from "../prodect/ProsConnect";
import {prosLog} from "../prodect/ProsConnect";
import {makeUiMainProjectList, SidePanel} from "../prodect/ProsCommonUi";
import {prosNotificationShow} from "../prodect/ProsPopup";
import {isShowingHelpDesk, setHelpContext} from "../prodect/HelpManager";
import AuthChangePwd from "./AuthChangePwd";
import {TermItems} from "./AcceptTerms";
import {VERS_STRING} from "../config";
import Checkbox from "../components/Checkbox";
import Spacer from "../components/Spacer";
import BasicButton, {CancelButton, ConfirmButton} from "../components/BasicButton";
import TextInput from "../components/TextInput";
import DropdownMenu from "../components/DropdownMenu";
import ToggleSwitch from "../components/ToggleSwitch";
import {MAIN_VIEW_NOTIFICATION_RULES} from "./Home";
import TabsNavigation from "../components/TabsNavigation";

const WEB_HELP_GDPR = "https://prodect.com/tietosuojaseloste/"

const PAGE_USER_SETTINGS = 'page_user'
const PAGE_USER_COMMUNICATIONS = 'page_comm'

export const ISO_WEEKDAYS = [
    {text: 'Maanantai', value: 1},
    {text: 'Tiistai', value: 2},
    {text: 'Keskiviikko', value: 3},
    {text: 'Torstai', value: 4},
    {text: 'Perjantai', value: 5},
    {text: 'Lauantai', value: 6},
    {text: 'Sunnuntai', value: 7}
]

export default class Settings extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            showHelpDesk: isShowingHelpDesk(),
            hasContentChanged: false,//change to true if ANYTHING changes on page, will show save button,
            activePage: PAGE_USER_COMMUNICATIONS,
            notificationDay: 0,
            ruleNotifications: true,
            ruleNotificationRecurringDay: 1,
            notificationForNewSubprojects: true,
            projNotify: {},
            mainProjNotify: {},
            forceRuleNotificationsDate: new Date(Date.now() + 1000 * 60 * 60 * 24 * 3),//Todo Jere: Temp for testing, should come from server
            email: prosConnect.getUserEmail(true),
            name: prosConnect.getUserName(),
            showSidePanel: false,
            commSettingsPage: 1
        }
        this.handleChangeCustomersEmail = this.handleChangeCustomersEmail.bind(this)
        this.weeklyAndRuleProjList = {}
        this.mainProjectList = []
        this.commSettingsProjectsListed = Math.round(UI_LISTED_ELEMENTS_LIMIT / 2)
    }

    async componentDidMount() {
        await this.setUiFromUserSettings()
        setHelpContext('comm-settings')
    }

    userInfo() {
        return <p>Olet kirjautuneena tunnuksella: <b>{getUserEmail(true)}</b></p>
    }

    deviceId() {
        return "Laitetunnus: " + getDevId()
    }

    toggleSuperUserMode() {
        let email = isSuperUserModeInUse() ? '' : this.state.testCustomersEmail || ''
        setSuperUserMode(!isSuperUserModeInUse(), email);
        this.setState( {refreshVar: this.state.refreshVar + 1})
    }

    toggleSuperUserOverridePermissions() {
        setSuperUserOverridePermissions(!isSuperUserOverridePermissionsInUse());
    }

    handleChangeCustomersEmail(val) {
        if (isSuperUserModeInUse()) {
            // ignore email change when in use
            this.setState( {refreshVar: this.state.refreshVar + 1})
            return
        }
        this.setState({
            testCustomersEmail: val
        })
    }

    goBack() {
        this.props.closeView()
    }

    async setUiFromUserSettings() {
        let notif_settings = await prosConnect.getUserNotifSettings();
        this.mainProjectList = await makeUiMainProjectList(OBJ_STATE_ACT)
        let projNotify = {}
        let ruleProjNotify = {}
        let notification_for_new = notif_settings[ATTR_NOTIFICATION_FOR_NEW_SUBPROJECTS] ?? true
        if ( ! (ATTR_RULE_PROJECTS in notif_settings) && ATTR_PROJECTS in notif_settings) {
            // Before weekly and rule notif shared project list. First time arriving in new settings will make copy of projects
            notif_settings[ATTR_RULE_PROJECTS] = notif_settings[ATTR_PROJECTS]
        }
        this.mainProjectList.forEach(mainProj => {
            mainProj.projects.forEach(proj => {
                if (ATTR_PROJECTS in notif_settings && Array.isArray(notif_settings[ATTR_PROJECTS])) {
                    let included_in_list = notif_settings[ATTR_PROJECTS].includes(proj.project_id)
                    projNotify[proj.project_id] = included_in_list !== notification_for_new
                } else {
                    projNotify[proj.project_id] = true
                }
                if (ATTR_RULE_PROJECTS in notif_settings && Array.isArray(notif_settings[ATTR_RULE_PROJECTS])) {
                    let included_in_list = notif_settings[ATTR_RULE_PROJECTS].includes(proj.project_id)
                    ruleProjNotify[proj.project_id] = included_in_list !== notification_for_new
                } else {
                    ruleProjNotify[proj.project_id] = true
                }
            })
        })
        this.weeklyAndRuleProjList[1] = ruleProjNotify // Workflow notif email - list of pids
        this.weeklyAndRuleProjList[2] = projNotify // Weekly notif email - list of pids
        this.setState({
            projNotify: ruleProjNotify,
            ruleNotifications: notif_settings[ATTR_RULE_NOTIFICATIONS] ?? true, // Workflow trigger type notifs - bool
            ruleNotificationRecurringDay: notif_settings[ATTR_RULE_NOTIFICATION_RECURRING_DAY] ?? 1, // Workflow recurring type notif - int to represent isoweekday 0=OFF
            notificationDay: notif_settings[ATTR_NOTIFICATION_DAY] ?? 0, // Weekly notif email notif day - isoweekday format 0=OFF
            notificationForNewSubprojects: true, // Defaults to true until user notification settings get redesigned - notification_for_new
            hasContentChanged: false,
        }, this.updateMainProjectNotifySelectionState)
        prosLog('setUiFromUserSettings')
    }

    async saveChanges() {
        this.setState({
            loading: true
        })
        let notif_settings = {}
        this.weeklyAndRuleProjList[this.state.commSettingsPage] = this.state.projNotify
        let projects = []
        let rule_projects = []
        for (let key in this.weeklyAndRuleProjList[2]){
            if (this.weeklyAndRuleProjList[2][key] !== this.state.notificationForNewSubprojects) {
                projects.push(key)
            }
        }
        for (let key in this.weeklyAndRuleProjList[1]){
            if (this.weeklyAndRuleProjList[1][key] !== this.state.notificationForNewSubprojects) {
                rule_projects.push(key)
            }
        }
        notif_settings[ATTR_PROJECTS] = projects
        notif_settings[ATTR_RULE_PROJECTS] = rule_projects
        notif_settings[ATTR_RULE_NOTIFICATIONS] = this.state.ruleNotifications
        notif_settings[ATTR_RULE_NOTIFICATION_RECURRING_DAY] = this.state.ruleNotificationRecurringDay
        notif_settings[ATTR_NOTIFICATION_DAY] = this.state.notificationDay
        notif_settings[ATTR_NOTIFICATION_FOR_NEW_SUBPROJECTS] = this.state.notificationForNewSubprojects
        prosLog("Saving user settings", 'newAttrs')
        await prosConnect.saveUserNotifSettings(notif_settings)
        prosNotificationShow(this, "Asetukset tallennettu")
        this.setState({
            loading: false,
            hasContentChanged: false
        })
    }

    async requestOneTimeNotification(main_project = undefined) {
        let notif_settings = {}
        let projects = []

        if (main_project) {
            main_project.projects.forEach(project => {
                if (project.project_id in this.state.projNotify && this.state.projNotify[project.project_id]) {
                    projects.push(project.project_id)
                }
            })
        } else {
            for (let key in this.state.projNotify){
                if (this.state.projNotify[key]) {
                    projects.push(key)
                }
            }
        }
        notif_settings[ATTR_PROJECTS] = projects
        notif_settings[ATTR_NOTIFICATION_FOR_NEW_SUBPROJECTS] = false
        await prosConnect.requestOneTimeNotification(notif_settings)
    }

    renderSaveCancelButtons(){
        if(!this.state.hasContentChanged) return null
        return <footer className="page-footer">
            <div className={"btn-set_center"}>
                <CancelButton
                    label={"Peru"}
                    action={()=> this.goBack()}
                />
                <ConfirmButton
                    label={"Tallenna"}
                    action={()=> this.saveChanges()}
                />
            </div>
        </footer>
    }

    renderTerms() {
        return <>
            {this.state.showTerms ?
                <div className={"settings-terms width-60_lg width-30_hd"}>
                    <TermItems/>
                </div>: null
            }
        </>
    }

    superUserMode() {
        if (isSuperUserModePossible()) {
            return <>
                <Spacer size={"lg"} line/>
                <div className="slab">
                    <p>Muuta sähköpostiosoitetta käyttämällä superuser oikeus päällä</p>
                    <h2>{"Testattava asiakkaan s-posti tunnus: " + getCustomerTestEmail()}</h2>
                    <TextInput
                        value={this.state.testCustomersEmail}
                        onChange={(val)=>this.handleChangeCustomersEmail(val)}
                    />
                </div>
                <div className="slab">
                    <ToggleSwitch
                        checked={isSuperUserModeInUse()}
                        label={"Käytä superoikeuksia"}
                        onChange={()=> this.toggleSuperUserMode()}
                    />
                    <Spacer/>
                    <Checkbox
                        text="Ohita testattavan käyttörajoitukset"
                        checked={isSuperUserOverridePermissionsInUse()}
                        disabled={!isSuperUserModeInUse()}
                        onChange={() => this.toggleSuperUserOverridePermissions()}
                    />
                </div>
                <div className={"slab"}>
                    <h3>
                        { isSuperUserModeInUse() ?
                            "Superoikeudet KÄYTÖSSÄ - ole varovainen":
                            "Superoikeudet ei käytössä" }
                    </h3>
                </div>
            </>
        }
        return null
    }

    renderHelpDeskControl(){
        return <li>
            <BasicButton
                label={"Näytä ohje"}
                icon={"help"}
                action={()=>{
                    this.props.toggleShowingHelpDesk()
                }}
                selected={this.props.showHelpDesk }
                hilite={this.props.showHelpDesk }
                shrink={"md"}
            />
        </li>
    }

    setActivePage(page) {
        if (page === this.state.activePage) {
            return
        }
        if (page === PAGE_USER_SETTINGS || page === PAGE_USER_COMMUNICATIONS) {
            this.setUiFromUserSettings()
        }
        // todo get customer perms etc
        this.setState({
            activePage: page
        })
        switch(page) {
            case PAGE_USER_SETTINGS: setHelpContext('settings'); break
            case PAGE_USER_COMMUNICATIONS: setHelpContext('comm-settings'); break
            default: setHelpContext('settings'); break
        }
    }

    toggleNotifications(key){
        this.setState({
            [key]: this.state[key] ? 0 : 1,
            hasContentChanged: true
        })
    }
    toggleRuleNotifications() {
        this.setState({
            ruleNotifications: !this.state.ruleNotifications,
            hasContentChanged: true
        })
    }

    toggleSelectedSubproject(subproject_id) {
        let jsonStr = JSON.stringify(this.state.projNotify);
        let projNotify = JSON.parse(jsonStr);
        if (subproject_id in projNotify) {
            projNotify[subproject_id] = ! projNotify[subproject_id]
        } else {
            projNotify[subproject_id] = true
        }
        this.setState({
            projNotify: projNotify,
            hasContentChanged: true,
        }, this.updateMainProjectNotifySelectionState)
    }

    toggleSelectedMainProject(main_project) {
        let checked = this.state.mainProjNotify[main_project.mainProjectId] === 'check'
        let jsonStr = JSON.stringify(this.state.mainProjNotify);
        let mainProjNotify = JSON.parse(jsonStr);
        jsonStr = JSON.stringify(this.state.projNotify);
        let projNotify = JSON.parse(jsonStr);
        main_project.projects.forEach(project => {
            projNotify[project.project_id] = ! checked
        })
        mainProjNotify[main_project.mainProjectId] = checked ? 'unchecked' : 'check'
        this.setState({
            projNotify: projNotify,
            mainProjNotify: mainProjNotify,
            hasContentChanged: true,
        })
    }

    updateMainProjectNotifySelectionState() {
        let jsonStr = JSON.stringify(this.state.mainProjNotify)
        let mainProjNotify = JSON.parse(jsonStr)
        this.mainProjectList.forEach(main_project => {
            if (main_project.projects.length > 0) {
                mainProjNotify[main_project.mainProjectId] = this.mainProjectNotificationSelectionStatus(main_project.projects)
            }
        })
        this.setState({
            mainProjNotify: mainProjNotify,
        })
        if(mainProjNotify.length < 1){
            this.setState({
                hasContentChanged: false
            })
        }
    }

    mainProjectNotificationSelectionStatus(subprojects) {
        let some_checked = false
        let filtered_projects = subprojects.filter(project => {
            if (project.project_id in this.state.projNotify) {
                some_checked = this.state.projNotify[project.project_id] ? true : some_checked
                return this.state.projNotify[project.project_id]
            }
            return false
        })
        let all_checked = filtered_projects.length === subprojects.length
        return all_checked ? 'check' : some_checked ? 'minus' : 'unchecked'
    }

    checkIfAnyProjectSelected() {
        return undefined !== Object.values(this.state.projNotify).find(proj => {
            return proj === true
        })
    }

    renderSelectNotificationDay(type) {
        if(!this.checkIfAnyProjectSelected()) return null
        return <div>
            <p className={"margin-bottom"}>Valitse päivä, jolloin {type === 'ruleNotificationRecurringDay' ? 'toistuva ilmoitus' : 'viikkotiedote'} lähetetään.</p>
            <DropdownMenu
                text={"Valitse päivä"}
                values={ISO_WEEKDAYS}
                currentValue={this.state[type]}
                onSelect={(val)=>{
                    this.setState({
                        [type]: val,
                        hasContentChanged: true
                    })
                }}
            />
        </div>
    }

    renderSubprojectEditor(subproject) {
        return <div key={subproject.project_id} className={"element-set"}>
            <Checkbox
                text={subproject.text}
                checked={this.state.projNotify[subproject.project_id] || false}
                onChange={() => this.toggleSelectedSubproject(subproject.project_id)}
            />
        </div>
    }

    // For weekly notification email
    renderSendAdhocSendButton(main_project) {
        if (isSuperUserModeInUse() && this.state.commSettingsPage === 2) {
            return <BasicButton
                btnClass={"2nd"}
                label={"Lähetä viesti"}
                action={() => this.requestOneTimeNotification(main_project)}
                size={"xs"}
                className={"margin-left"}
            />
        }
    }

    renderSidePanelEditor() {
        return <>
            {this.mainProjectList.map((project, index) => {
                return this.renderMainProjectEditor(project, index + 1)
            })}
        </>
    }

    renderMainProjectEditor(main_project, mindex) {
        if (main_project.customerGroup === 'EXAMPLES') {
            return null
        }
        let checkCollapse = 'check_collapse_' + mindex
        let isChecked = this.state.mainProjNotify[main_project.mainProjectId] === 'check'
        if(this.state.mainProjNotify[main_project.mainProjectId] === 'minus') isChecked = 'partial'
        return <label key={'checkCollapse__'+checkCollapse} htmlFor={checkCollapse} className="collapse-left">
            <input type="checkbox" id={checkCollapse} name={checkCollapse} value={mindex} defaultChecked={false}/>
            <i className="ui-icon ui-icon ui-icon-chevron-down ui-icon_color-main" title="Avaa" />
            <span className={"element-set"}>
                <Checkbox
                    text={main_project.name}
                    checked={isChecked}
                    onChange={() => this.toggleSelectedMainProject(main_project)}
                />
            </span>
            <span className="collapse-container">
                <span className="collapse-content">
                    <span className="selection-group selection-group-check">
                        {main_project.projects.map(project => {
                            return this.renderSubprojectEditor(project)
                        })}
                    </span>
                </span>
            </span>
        </label>
    }

    renderProjects(main_project, mindex, key) {
        if (main_project.customerGroup === 'EXAMPLES'
            || this.state.mainProjNotify[main_project.mainProjectId] === 'unchecked') return false
        let sublist = []
        main_project.projects.forEach(subproject => {
            if(this.state.projNotify[subproject.project_id]) sublist.push(this.renderSubproject(subproject))
        })
        return <div key={"renderProjects__" + mindex}>
            <h4>{main_project.name}{this.renderSendAdhocSendButton(main_project)}</h4>
            <ul className={"element-indented"}>
                {sublist.slice(0, this.commSettingsProjectsListed)}
            </ul>
            {this.renderHasMore(sublist.length, main_project.projects.length, key)}
            <p className={"text-xs"}><span className={"custom-info-thing"}>{sublist.length}/{main_project.projects.length}</span> valittu</p>
        </div>
    }

    renderHasMore(selectedAmount, allAmount){
        if(selectedAmount <= this.commSettingsProjectsListed) return null
        return <BasicButton
            btnClass={"primary"}
            icon={"plus"}
            label={(allAmount - this.commSettingsProjectsListed) + " lisää"}
            size={"md"}
            action={()=>{
                this.setState({showSidePanel: true})
            }}
            className={"margin-bottom"}
        />
    }

    renderSubproject(subproject){
        return <li key={subproject.project_id} className={"element-set-xs valign-center"}>
            <span>{subproject.text}</span>
            {subproject[ATTR_USER_ROLE] === ROLE_ADMIN &&
                <BasicButton
                    btnClass={"primary"}
                    icon={"bell"}
                    action={()=> {
                        this.props.projectSelected(subproject)
                        this.props.setMainView(MAIN_VIEW_NOTIFICATION_RULES)
                    }}
                    size={"md"}
                    className={"margin-left-sm"}
                    tooltip={["Siirry ilmoituksiin"]}
                />}
        </li>
    }

    renderNotificationProjects() {
        let projectsList = []
        this.mainProjectList.forEach((project, index) => {
            const returnElement = this.renderProjects(project, index + 1)
            if(returnElement) projectsList.push(this.renderProjects(project, index + 1))
        })
        return <>
            {projectsList.length > 0 ? <div className={"grid-container grid-3_lg grid-4_hd flex-wrap margin-top margin-bottom card"}>
                {projectsList}
                </div> : null}
            <div className={"btn-set" + (projectsList.length > 0 ? "_center" : "")}>
                <BasicButton
                    btnClass={"primary"}
                    icon={"check-list"}
                    label={"Valitse projektit"}
                    action={()=> {
                        this.setState({showSidePanel: !this.state.showSidePanel})
                    }}
                    selected={this.state.showSidePanel}
                />
            </div>
        </>
    }

    renderUserSettings() {
        const hasNameChanged = this.state.name !== prosConnect.getUserName()
        return <section>
            <div className={"slab width-60_lg width-30_hd"}>
                <h2>Käyttäjän asetukset</h2>
                {this.userInfo()}
                <h3>Muokkaa nimeä</h3>
                <TextInput
                    label={"Nimi"}
                    id={"name"}
                    autoFocus
                    value={this.state.name}
                    onChange={val=> {
                        this.setState({
                            name: val
                        })
                    }}
                    onSubmit={hasNameChanged ? val =>{
                            prosConnect.setUserName(val)
                            prosNotificationShow(this, "Nimi muutettu")
                            this.setState({
                                name: val
                            })
                        } : null}
                    placeholder={"Kirjoita nimesi"}
                    required
                    isValid={this.state.name.length > 0}
                    isControlled={true}
                />
                <TextInput
                    id={"email"}
                    label={"Sähköposti"}
                    type={"email"}
                    value={this.state.email}
                    disabled
                />
            </div>
            <div className={"slab width-60_lg width-30_hd"}>
                <AuthChangePwd />
            </div>
            <Spacer size={"xl"}/>
            <div className={"slab"}>
                <div className={"grid-container grid-1 grid-2_lg width-60_lg width-30_hd"}>
                    <BasicButton
                        btnClass={"2nd"}
                        label={this.state.showTerms ? 'Sulje käyttäjäehdot' : 'Näytä käyttäjäehdot'}
                        icon={this.state.showTerms ? "chevron-up" : "chevron-down"}
                        action={() => this.setState({showTerms: !this.state.showTerms})}
                        selected={this.state.showTerms}
                    />
                    <BasicButton
                        btnClass={"2nd"}
                        label={"Tietosuojaseloste"}
                        icon={"open-new"}
                        href={WEB_HELP_GDPR}
                        target={"_blank"}
                    />
                </div>
                <Spacer size={"lg"}/>
                {this.renderTerms()}
            </div>
            {this.superUserMode()}
            <div className={"slab"}>
                <p>{VERS_STRING}</p>
                <p>{this.deviceId()}</p>
            </div>
        </section>
    }

    renderTabsNavigation(){
        let linkValues = [{
            value: 1,
            text: 'Ilmoitukset',
            selected: this.state.commSettingsPage === 1
        },{
            value: 2,
            text: 'Viikkotiedote',
            selected: this.state.commSettingsPage === 2
        }]
        return <TabsNavigation values={linkValues} callback={val=> {
                this.weeklyAndRuleProjList[val === 2 ? 1 : 2] = this.state.projNotify
                this.setState({
                    projNotify: this.weeklyAndRuleProjList[val],
                    commSettingsPage: val,
                    showSidePanel: false,
                }, () => this.updateMainProjectNotifySelectionState())
            }}
            currentTab={this.state.commSettingsPage}
            className={"margin-top"}
        />
    }

    renderNotificationsPage(){
        return <>
            <div>
                <p>Viikkotiedote on sähköpostilla toimitettu viesti, johon on koottu osaprojektissa viikon aikana tapahtuneet muutokset ja lisäykset.</p>
                <ToggleSwitch
                    label={"Lähetä viikkotiedote"}
                    checked={this.state.notificationDay}
                    onChange={() => this.toggleNotifications('notificationDay')}
                />
                <Spacer size={"lg"} />
                {this.state.notificationDay ? this.renderSelectNotificationDay('notificationDay') : null}
            </div>
            <div>
                {this.state.notificationDay  ? this.renderNotificationProjects() : null}
            </div>
        </>
    }

    renderNotificationRulesPage(){
        return <div>
            <p>Ilmoituksia luodaan ja muokataan osaprojektin Ilmoitukset-sivulla.</p>
            <div className={"margin-top grid-container grid-1 grid-2_lg"}>
                <div>
                    <h6>Toistuvat ilmoitukset</h6>
                    <ToggleSwitch
                        label={"Lähetä toistuvat ilmoitukset"}
                        checked={this.state.ruleNotificationRecurringDay}
                        onChange={()=>this.toggleNotifications('ruleNotificationRecurringDay')}
                    />
                    <p className={"margin-top text-sm"}>Toistuvaan ilmoitukseen kerätään ehtojen mukaiset muutokset viikon ajalta.</p>
                    {this.state.ruleNotificationRecurringDay ? this.renderSelectNotificationDay('ruleNotificationRecurringDay') : null}
                </div>
                <div>
                    <h6>Muutosilmoitukset</h6>
                    <ToggleSwitch
                        label={"Lähetä muutosilmoitukset"}
                        checked={this.state.ruleNotifications}
                        onChange={()=>this.toggleRuleNotifications()}
                    />
                    <p className={"margin-top text-sm"}>Muutosilmoitus on viesti, joka lähetään heti kun joku määritellyistä ehdoista täyttyy.</p>
                </div>
            </div>
            {this.state.ruleNotificationRecurringDay || this.state.ruleNotifications ? this.renderNotificationProjects() : null}
        </div>
    }

    renderCommSettings(){
        if(!prosConnect.userHasMainProjects() || !prosConnect.userHasSubProjects()) return <h2>Ei projekteja.</h2>
        return <>
            {this.renderTabsNavigation()}
            <section>
                <div className="slab">
                    {this.state.commSettingsPage === 2 ? this.renderNotificationsPage() : this.renderNotificationRulesPage()}
                </div>
            </section>
            <SidePanel
                title={this.state.commSettingsPage === 2 ? 'Viikkotiedote' : 'Ilmoitukset'}
                show={this.state.showSidePanel}
                closeCallback={() => this.setState({showSidePanel: false})}
            >{this.renderSidePanelEditor()}</SidePanel>
            {this.renderSaveCancelButtons()}
        </>
    }

    // renderHeaderMainButton(page, icon, tabIndex, title) {
    //     return <BasicButton
    //         label={title}
    //         icon={icon}
    //         action={() => { this.setActivePage(page) }}
    //         selected={this.state.activePage === page}
    //         tabIndex={tabIndex}
    //         shrink={"lg"}
    //     />
    // }

    renderMainHeader() {
        const title = this.state.activePage === PAGE_USER_COMMUNICATIONS ? 'Viestintä' : 'Asetukset'
        return <header className="page-header">
            <h1>{title}</h1>
        </header>
    }

    renderContent() {
        switch(this.state.activePage) {
            case PAGE_USER_SETTINGS: return this.renderUserSettings()
            case PAGE_USER_COMMUNICATIONS: return this.renderCommSettings()
            default: return <h2>{"ERR no render for page:" + this.state.activePage}</h2>
        }
    }

    render() {
        require("./assets/scss/Settings.scss")
        return <>
            {this.renderMainHeader()}
            <div className={"side-nav-container"}>
                <nav className={"side-nav"}>
                    <ul className={"navigation"}>
                        <li>
                            <BasicButton
                                label={"Alkuun"}
                                icon={"arrow-left"}
                                action={()=>{
                                    this.setState({showTerms: false}, () => this.goBack())
                                }}
                                shrink={"md"}
                            />
                        </li>
                        <li>
                            <BasicButton
                                label={"Viestintä"}
                                icon={"bell"}
                                action={()=>{
                                    this.setActivePage(PAGE_USER_COMMUNICATIONS)
                                }}
                                selected={this.state.activePage === PAGE_USER_COMMUNICATIONS}
                                hilite={this.state.activePage === PAGE_USER_COMMUNICATIONS}
                                shrink={"md"}
                            />
                        </li>
                        <li>
                            <BasicButton
                                label={"Käyttäjä"}
                                icon={"user"}
                                action={()=>{
                                    this.setActivePage(PAGE_USER_SETTINGS)
                                }}
                                selected={this.state.activePage === PAGE_USER_SETTINGS}
                                hilite={this.state.activePage === PAGE_USER_SETTINGS}
                                shrink={"md"}
                            />
                        </li>
                        <li>
                            <BasicButton
                                label={"Kirjaudu ulos"}
                                icon={"sign-out"}
                                action={this.props.handleLogout}
                                shrink={"md"}
                            />
                        </li>
                        {this.renderHelpDeskControl()}
                    </ul>
                </nav>
                <div className={"side-nav-page"}>{this.renderContent()}</div>
            </div>
        </>
    }
}